// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-spinkit/css/folding-cube.css
// module id = 1232
// module chunks = 0